import type { ProblemPayload } from "../../../api/threads/liveMessages";
import type { UiError } from "../../../errors/uiError";

type RecordedProblem = ProblemPayload["problem"];

/**
 * A problem recorded in the log (a `problem` entry, or a failed turn's problem) as the one
 * error type, so it is worded by code like every other error (NFR-5). It is history, not a
 * failed request: it has no request to quote.
 */
export function recordedProblemError(problem: RecordedProblem): UiError {
  return {
    kind: "problem",
    problem: {
      type: `urn:dmw:error:${problem.code}`,
      title: problem.title,
      status: problem.status,
      detail: problem.detail,
      instance: "",
      code: problem.code,
      requestId: "",
      details: problem.details,
    },
  };
}
